import React from "react";
const Svg = ({ width, height, style, className, clearHover, children, resizeWithWindow, onClick }) => (React.createElement("div", { className: "svg-container", style: {
        ...style,
        ...(!resizeWithWindow
            ? {
                width: `${width}px`,
                height: `${height}px`,
                overflow: "visible"
            }
            : {})
    } },
    React.createElement("svg", { className: `svg-content ${className}`, viewBox: `-${width / 2} -${height / 2} ${width} ${height}`, preserveAspectRatio: "xMidYMid meet", style: { overflow: "visible" } },
        React.createElement("g", null,
            React.createElement("rect", { fillOpacity: 0, height: height, onClick: (event) => {
                    clearHover();
                    onClick?.(event);
                }, width: width, x: `-${width / 2}`, y: `-${height / 2}` }),
            children))));
export default Svg;
